import type { BrowserWindow, TurnstileRuntimeState } from './types'

export const getRuntimeState = (windowRef: BrowserWindow): TurnstileRuntimeState => {
  if (!windowRef.__emporionTurnstileRuntimeState) {
    windowRef.__emporionTurnstileRuntimeState = {
      loadPromise: null,
      containerWidgets: new WeakMap<HTMLElement, string>(),
      activeWidgetIds: new Set<string>(),
    }
  }
  return windowRef.__emporionTurnstileRuntimeState
}

export const resolveApiIfReady = () => {
  if (typeof window === 'undefined') return null
  const browserWindow = window as BrowserWindow
  return browserWindow.turnstile ?? null
}
